import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-color',
    templateUrl: './color.component.html',
    styleUrls: ['./color.component.scss'],
    standalone: false
})
export class ColorComponent implements OnInit {

  @Input() color: string;


  constructor() { }

  ngOnInit() {
  }

}
